export const ResizeObserver = window.ResizeObserver